/* istanbul ignore file */
import de from "./vf-footer-de";
import eg from "./vf-footer-eg";
import es from "./vf-footer-es";
import gb from "./vf-footer-gb";
import pt from "./vf-footer-pt";
import lw from "./vf-footer-lw";
import za from "./vf-footer-za";
import ro from "./vf-footer-ro";
import cz from "./vf-footer-cz";
import tr from "./vf-footer-tr";
import gr from "./vf-footer-gr";
import nl from "./vf-footer-nl";

import {
  OpcoDe,
  OpcoEs,
  OpcoGb,
  OpcoEg,
  OpcoPt,
  OpcoLw,
  OpcoZa,
  OpcoRo,
  OpcoCz,
  OpcoTr,
  OpcoGr,
  OpcoNl,
} from "types/Opco";

export type FooterConfigType = {
  withdrawal?: string;
  "privacy-policy"?: string;
  "terms-and-conditions"?: string;
  "help-and-support"?: string;
  "cookie-preferences"?: string;
  accessibility?: string;
  imprint?: string;
  "terminate-contract"?: string;
};

const configs: Record<
  OpcoDe | OpcoEs | OpcoGb | OpcoEg | OpcoPt | OpcoLw | OpcoZa | OpcoRo | OpcoCz | OpcoTr | OpcoGr | OpcoNl,
  FooterConfigType
> = {
  de,
  es,
  gb,
  eg,
  pt,
  lw,
  za,
  ro,
  cz,
  tr,
  gr,
  nl,
};

export default configs;
